// extracted by mini-css-extract-plugin
module.exports = {"item":"Sorter_item__2J10X","footer":"Sorter_footer__2JGuq","primary":"Sorter_primary__2mRJT"};